<div *ngIf="!isChoice" class="cookie-container container-fluid no-gutters d-flex align-items-center">
  <div class="row mx-auto">
    <div class="col-12 w-100">
      <span>{{cookieMessage}}</span>
      <button (click)="onChoice(true)" class="cookie-button white">Accepter</button>
      <button (click)="onChoice(false)" class="cookie-button transparent">Refuser</button>
    </div>
  </div>
</div>
